// extracted by mini-css-extract-plugin
module.exports = {"HeadingwithLongDescriptionBanner":"HeadingwithLongDescriptionBanner_HeadingwithLongDescriptionBanner__qAP3o"};